export default __webpack_public_path__ + "static/media/IMG_1436.81be3613.81be3613.JPG";